import { getData } from './httpClient';

/**
 * Valida disponibilidad de stock para una lista de productos.
 * @returns {{ ok: true } | { ok: false, message: string, shortages: Array }}
 */
export async function validateStockForProducts(products, vehicleServiceId) {
  const byProduct = {};
  const metaById = {};

  for (const p of products || []) {
    if (!p.productId) continue;
    const pid = String(p.productId);
    const qty = Number(p.quantity) || 0;
    if (qty <= 0) continue;
    byProduct[pid] = (byProduct[pid] || 0) + qty;
    if (!metaById[pid]) {
      metaById[pid] = p;
    }
  }

  const shortages = [];

  for (const [productId, qty] of Object.entries(byProduct)) {
    const qs = vehicleServiceId ? `?vehicleServiceId=${vehicleServiceId}` : '';
    const res = await getData(`/stock/availability/${productId}${qs}`, {
      skipLoader: true,
    });
    if (res?.payload?.stockTracked === false) {
      continue;
    }
    const effective =
      res?.payload?.effectiveAvailable ?? res?.payload?.totalAvailable ?? 0;

    if (qty > effective) {
      const meta = metaById[productId] || {};
      shortages.push({
        productId: Number(productId),
        name:
          meta.productName ||
          meta.product?.name ||
          meta.name ||
          `Producto #${productId}`,
        requested: qty,
        available: effective,
      });
    }
  }

  if (shortages.length === 0) {
    return { ok: true };
  }

  const message = shortages
    .map(
      (s) =>
        `${s.name}: necesita ${s.requested}, disponible ${s.available}`,
    )
    .join(' · ');

  return { ok: false, message, shortages };
}
